import React, { useState } from 'react'
import { useEditAssignmentMarkMutation } from '../../features/assignmentMarks/assignmentMarksApi';
import { getFormattedDate } from '../../utils/getFormattedDate';

function AssignmentMark({ mark }) {
	//Variblees
	const { id, student_name, title, createdAt, totalMark, mark: getMark, repo_link, status } = mark || {};
	const [editAssignmentMark] = useEditAssignmentMarkMutation();

	//States
	const [assignMark, setAssignMark] = useState(getMark || 0);

	//Functions
	const handleChange = (e) => {
		const { name, value } = e.target;
		if (name === 'assignMark') {
			if (value >= 0 && value <= totalMark) {
				setAssignMark(value);
			}
		}
	}


	const handleAssignMark = (mark) => {
		const payload = { mark: Number(assignMark), status: 'published' }
		if (id) editAssignmentMark({ id, data: payload });
	}

	return (
		<tr>
			<td className="table-td">{title}</td>
			<td className="table-td">{getFormattedDate(createdAt)}</td>
			<td className="table-td">{student_name}</td>
			<td className="table-td">{repo_link}</td>
			{status === 'pending' ?
				<td className="table-td input-mark">
					<input max="100" id="assignMark" name="assignMark" value={assignMark} onChange={(e) => handleChange(e)} />
					<svg fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor"
						className="w-6 h-6 text-green-500 cursor-pointer hover:text-green-400" onClick={(id) => handleAssignMark(id)}>
						<path strokeLinecap="round" strokeLinejoin="round"
							d="M4.5 12.75l6 6 9-13.5" />
					</svg>
				</td>
				: <td className="table-td">{getMark}</td>
			}


		</tr>
	)
}

export default AssignmentMark